/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateManufacturerDto } from '../../models/create-manufacturer-dto';
import { ManufacturerCompany } from '../../models/manufacturer-company';

export interface CreateOneBaseMgmtManufacturerControllerManufacturerCompany$Params {
      body: CreateManufacturerDto
}

export function createOneBaseMgmtManufacturerControllerManufacturerCompany(http: HttpClient, rootUrl: string, params: CreateOneBaseMgmtManufacturerControllerManufacturerCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<ManufacturerCompany>> {
  const rb = new RequestBuilder(rootUrl, createOneBaseMgmtManufacturerControllerManufacturerCompany.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ManufacturerCompany>;
    })
  );
}

createOneBaseMgmtManufacturerControllerManufacturerCompany.PATH = '/api/mgmt/manufacturers';
